import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ShadowBox, Heading, Box, Button, Text } from '@components/common';
import TableCell from '@components/TableCell';
import TimeWindowModal from '@containers/booking/TimeWindowModal';
import { MobileContainer, DesktopContainer } from '@containers/layout';
import TimeframeBoardView from './TimeframeBoardView';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import { AppSelectors } from '@redux/AppRedux';
import { TIME_FRAME, TIME_FRAME_TITLES } from '@services/minte';

const DesktopWrapper = styled(DesktopContainer)`
  @media screen and (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;
  z-index: 100;
  @media screen and (max-width: 767px) {
    flex: 0;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding-top: 0px;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

const MobileOnly = styled(Box)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const DesktopOnly = styled(Box)`
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: block;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
`;

const WeekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function TimeframeRecurring(props) {
  const {
    onSubmit,
    selectedItems,
    appData,
    updateRecurringServiceDate
  } = props;
  const [currentTimeItem, setTimeItem] = useState(null);
  const [showTimeModal, setShowTimeModal] = useState(false);

  const isDisabled = !selectedItems;

  let listItems = [];

  const {
    serviceDate: workingServiceDate,
    timeframe: workingTimeFrame
  } = currentTimeItem || {
    serviceDate: {},
    timeframe: TIME_FRAME.ANYTIME
  };

  listItems = selectedItems.map(item => {
    const { serviceType, col } = item;

    const { serviceTypes } = appData;
    const { title } = serviceTypes[serviceType];
    const weekDay = WeekDays[+col];

    return {
      title,
      weekDay,
      item
    };
  });

  return (
    <DesktopWrapper>
      <MobileOnly>
        <Button
          my={2}
          width={1}
          type="button"
          onClick={onSubmit}
          disabled={isDisabled}
        >
          Continue
        </Button>
      </MobileOnly>
      <TimeframeBoardView
        onSelect={oldItem => {
          setTimeItem(oldItem);
          setShowTimeModal(true);
        }}
      />

      <ContainerView>
        <Box position="relative" pt={[4, 0]}>
          <Heading display={['none', 'block']} px={2} mb={4} mt={0}>
            Time
          </Heading>
          <Text textAlign={['center', 'left']} px={2} mb={4}>
            Here's your upcoming schedule for you to double check.
          </Text>
          <ShadowBox mb={4}>
            {listItems.map(listItem => {
              const { title, weekDay, item } = listItem;
              const { row, col, serviceType, timeframe } = item;
              const key = `clean__${row}__${col}`;
              return (
                <TableCell
                  key={key}
                  leftIcon={serviceType}
                  title={`${title}, ${weekDay}`}
                  rightIcons={[timeframe]}
                  rightIconColor="gold"
                  rightText={TIME_FRAME_TITLES[timeframe]}
                  onClick={() => {
                    setTimeItem(item);
                    setShowTimeModal(true);
                  }}
                />
              );
            })}
          </ShadowBox>
          <DesktopOnly>
            <Button
              my={4}
              width={1}
              type="button"
              onClick={onSubmit}
              disabled={isDisabled}
            >
              Continue
            </Button>
          </DesktopOnly>
        </Box>
      </ContainerView>
      <TimeWindowModal
        dismiss={() => {
          setShowTimeModal(false);
        }}
        timeframe={workingTimeFrame}
        show={showTimeModal}
        onSubmit={newTimeframe => {
          updateRecurringServiceDate({
            ...currentTimeItem,
            timeframe: newTimeframe,
            serviceDate: {
              ...workingServiceDate,
              timeframe: newTimeframe
            }
          });
          setShowTimeModal(false);
        }}
      />
    </DesktopWrapper>
  );
}

TimeframeRecurring.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  selectedItems: PropTypes.array,
  appData: PropTypes.object,
  updateRecurringServiceDate: PropTypes.func
};

const mapStatesToProps = state => ({
  appData: AppSelectors.selectAppData(state),
  selectedItems: ScheduleSelectors.selectScheduledItems(state)
});

const mapDispatchToProps = dispatch => ({
  updateRecurringServiceDate: newItem =>
    dispatch(ScheduleActions.updateSelectedItem(newItem))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(TimeframeRecurring);
